import React, { useEffect, useState } from 'react';
import './AdminDashboardPageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";
import DashboardPanelAdminQuestionRAGBarStats from "root/Dashboard/DashboardPanelAdminQuestionRAGBarStats";
import { useParams } from "react-router-dom";
import { getSectionDetails } from "root/DataFunctions/SectionFns";
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

const AdminRAGReportPage = ( props ) =>
{
    let { section_number } = useParams ();

    const [ data, setData ] = useState ( { loading: true, data: [] } );

    useEffect ( () =>
    {
        getData ();
    }, [] );

    const getData = () =>
    {
        getSectionDetails ( section_number, ( response ) =>
        {
            const returnData = getDataFromResponse ( response );

            setData ( { loading: false, data: returnData } )
        } )
    }

    const composeSectionRef = (record) =>
    {
        const hasRef = record.section_ref !== null ;

        const refText = hasRef ? record.section_ref + '. ' : '' ;

        return refText ;
    }

    const sectionName = () =>
    {
        const rec = data.data[0] ;

        return composeSectionRef( rec ) + rec.table_section_name ;
    }

    return data.loading === true ? <SpinnerDiv/> :
        <PageBodyWrapper title={ sectionName() + ' - All Questions Report' } backButton={ true }>
            <div className='manage-grid-rows'>
                <div className='dash-style'>
                    <DashboardPanelAdminQuestionRAGBarStats title='Question RAG Status - All Schools'/>
                </div>
            </div>
        </PageBodyWrapper>
}

export default AdminRAGReportPage;
